
import React, { useState, useEffect } from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FiTruck, FiCheckCircle, FiCreditCard } from 'react-icons/fi';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductDetails.css';
import { useProducts } from '../../store/ProductContext';
import LoadingForAll from '../../Pages/LoadingForAll';
import { useUser } from '../../store/UserContext';
import { db } from '../../firebase/Config';
import { collection, addDoc, getDocs, query, where, updateDoc, doc } from 'firebase/firestore';
  function ProductDetails() {
  const {id} = useParams()
  const navigate=useNavigate()
  const {fetchProductById,products ,loading, error } = useProducts()
  const {currentUser}=useUser()
  const [product, setProduct] = useState(null);
  const [Loading, setLoading] = useState(true);
  const [Error, setError] = useState(null);
  const [mainImage, setMainImage] = useState('');
  const [load,setLoad]=useState({})
  const [cartErr,setCartErr]=useState('')
  useEffect(()=>{
    const loadProducts=async()=>{
      try{
        setLoading(true) 
        const productData=await fetchProductById(id)
        setProduct(productData)
        setMainImage(productData.imageUrls?.imageUrl1 || '')
        setLoading(false)
      }catch(err){
        setError(err.message)
        setLoading(false)
      }
    }
    loadProducts()
  },[id,fetchProductById])

  if (Loading) return <div><LoadingForAll title='Loading product details...'/></div>;
  if (Error) return <div>Error: {Error}</div>;
  if (!product) return <div>Product not found</div>;


  const handleAddToCart=async(product)=>{
    setLoad(prev=>({...prev, [product.id]:true}))
    try{
      if(!currentUser){
        navigate('/login')
        return
      }

      const cartQuery=query(collection(db,'cart'),where('userId','==',currentUser.uid),where('productId','==',product.id))
      const cartSnapshot=await getDocs(cartQuery)
      if(!cartSnapshot.empty){
        const cartDoc=cartSnapshot.docs[0]
        const cartData=cartDoc.data()
        const newQuantity=cartData.quantity+1
        await updateDoc(doc(db,'cart',cartDoc.id),{quantity:newQuantity})
      }
      
      else{
      await addDoc(collection(db,'cart'),{
        userId:currentUser.uid,
        productId:product.id,
        productName:product.title,
        quantity:1,
        price:product.pricing.ourPrice,
        imageUrl:product.imageUrls?.imageUrl1
      })
    }
    
    }catch(err){
      setCartErr(err.message)
      setLoad(prev=>({...prev, [product.id]:false}))
    }finally{
      setLoad(prev=>({...prev, [product.id]:false}) )
    }

   }

  return (
      <div className="product-details-container">
      {/* Back Button */}
      <button className="back-button" onClick={()=>navigate(-1)}>
        <FaChevronLeft /> Back to Products
      </button>
      
      <div className="product-details-content">
        {/* Product Images */}
        <div className="product-images">
          <div className="main-image">
            <img src={mainImage || product.imageUrls?.imageUrl1 || 'https://via.placeholder.com/500'} alt={product.title} />
          </div>

          <div className="thumbnail-images">

            <div className={`thumbnail ${mainImage === product.imageUrls.imageUrl1 ? 'active' : ''}`}
                           onClick={() => setMainImage(product.imageUrls.imageUrl1)}>
              <img src={product.imageUrls?.imageUrl1} alt="Thumbnail 1" />
            </div>

            <div className={`thumbnail ${mainImage === product.imageUrls.imageUrl2 ? 'active' : ''}`}
                         onClick={() => setMainImage(product.imageUrls.imageUrl2)}>
              <img src={product.imageUrls?.imageUrl2} alt="Thumbnail 2" />
            </div>

            <div className={`thumbnail ${mainImage === product.imageUrls.imageUrl3 ? 'active' : ''}`}
                         onClick={() => setMainImage(product.imageUrls.imageUrl3)}>
              <img src={product.imageUrls?.imageUrl3} alt="Thumbnail 3" />
            </div>

          </div>
        </div>
        
        {/* Product Info */}
        <div className="product-info">
          <h1 className="product-title">{product.title}</h1>
          
            <div className="product-rating">
                  {product.rating !== undefined ? (
                    <div className="stars">
                      {[1, 2, 3, 4, 5].map((star) => {
                        const ratingValue = Number(product.rating) || 0;
                        return (
                          <span key={star}>
                            {ratingValue >= star ? (
                              <FaStar className="star filled" />
                            ) : ratingValue >= star - 0.5 ? (
                              <FaStarHalfAlt className="star half" />
                            ) : (
                              <FaRegStar className="star" />
                            )}
                          </span>
                        );
                      })}
                      <span className="rating-number">
                        {(Number(product.rating) || 0).toFixed(1)}
                      </span>
                    </div>
                  ) : (
                    <div className="no-rating">No ratings yet</div>
                  )}
                </div>
          
          <div className="price-section">
             <div className="current-price">${product.pricing?.ourPrice?.toFixed(2)}</div>
            <div className="original-price">${product.pricing?.marketPrice?.toFixed(2)}</div>
            <div className="discount">{product.pricing?.offer?.toFixed(2)}% OFF</div>
          </div>
          
          <div className="availability">
            <FiCheckCircle className="availability-icon" />
            <span>{product.stock>0? 'In Stock' : 'Out of Stock'}</span>
          </div>
          
          <div className="delivery-options">
            <div className="delivery-option">
              <FiTruck className="delivery-icon" />
              <span>{product.deliveryOption === 'Free' ? 'FREE' : 'Paid'} delivery</span>
            </div>
            <div className="delivery-option">
              <FiCreditCard className="delivery-icon" />
              <span></span>
            </div>
          </div>
          
          <div className="product-description">
            <h3>About this item</h3>
            <p>
              {product.details}
            </p>
          </div>
          
          <div className="product-actions">
            <button className={`add-to-cart ${load[product.id] ? 'loadingProduct' : ''}`} onClick={()=>{
              handleAddToCart(product)
            }}>{load[product.id] ? 'Adding...' : 'Add to Cart'}</button>
            {cartErr && <p className="error-message">{cartErr}</p>} 
            
          </div>
        </div>
      </div>
      
      {/* Product Specifications */}
      <div className="product-specs">
        <h2>Specifications</h2>
        <div className="specs-grid">
          <div className="spec-row">
            <div className="spec-name">Brand</div>
            <div className="spec-value">-</div>
          </div>
          <div className="spec-row">
            <div className="spec-name">Model Name</div>
            <div className="spec-value">-</div>
          </div>
          <div className="spec-row">
            <div className="spec-name">Storage</div>
            <div className="spec-value">-</div>
          </div>
          <div className="spec-row">
            <div className="spec-name">Color</div>
            <div className="spec-value">-</div>
          </div>
          <div className="spec-row">
            <div className="spec-name">Screen Size</div>
            <div className="spec-value">-</div>
          </div>
          <div className="spec-row">
            <div className="spec-name">Operating System</div>
            <div className="spec-value">-</div>
          </div>
        </div>
      </div>
      
      
    </div>
  )
}

export default ProductDetails